import { Component, OnInit } from '@angular/core';
import { LayoutComponent } from "../../shared/layout/layout.component";
import { TranslatePipe } from '@ngx-translate/core';
import { ToggleComponent } from '../../shared/toggle/toggle.component';
import { GigyaService } from '../../services/gigya.service';
import { ButtonComponent } from '../../shared/button/button.component';
import { SpinnerComponent } from '../../shared/icons/spinner/spinner.component';
import { WarningIconComponent } from '../../shared/icons/warning/warning.component';
import { TitleUnderlineIconComponent } from '../../shared/icons/title-underline/title-underline.component';

@Component({
  selector: 'app-mfa-status',
  standalone: true,
  imports: [LayoutComponent, TranslatePipe, ToggleComponent, ButtonComponent, SpinnerComponent, WarningIconComponent, TitleUnderlineIconComponent],
  templateUrl: './mfa-status.component.html',
  styleUrl: './mfa-status.component.css'
})
export class MfaStatusComponent implements OnInit {

  public checked = false;
  public loading = false;
  public error = false;

  constructor(
    private gigyaService: GigyaService,
  ) {}

  public ngOnInit(): void {
    if (this.gigyaService.data && (this.gigyaService as any).data['rbaPolicy'] && (this.gigyaService as any).data['rbaPolicy']['riskPolicy'] === "enforce_tfa_for_every_login") {
      this.checked = true;
    }
  }

  public toggleMfa(event: boolean) {
    this.checked = event;
  }

  public submit() {
    if (this.checked) {
      this.enable();
    } else {
      this.disable();
    }
  }

  public async disable() {
    this.loading = true;
    const res = await this.gigyaService.execute(
      this.gigyaService.client.accounts.setAccountInfo,
      {
        rba: {
          riskPolicy: null
        }
      }
    )
    this.loading = false;
    if (res.errorCode !== 0) {
      this.error = true;
      return;
    }
    this.gigyaService.redirectToContinue();
  }

  public async enable() {
    this.loading = true;
    const res = await this.gigyaService.execute(
      this.gigyaService.client.accounts.setAccountInfo,
      {
        rba: {
          riskPolicy: "enforce_tfa_for_every_login"
        }
      }
    )
    this.loading = false;
    if (res.errorCode !== 0) {
      this.error = true;
      return;
    }
    this.gigyaService.redirectToContinue();
  }

}
